<!--  -->
<template>
<div class='help'>
    <div class="title">
      当前位置: <span class="home-page" @click="toHomePage()">首页</span> > <span>{{ title }}</span>
    </div>
        <div class="content">
      <div class="left">
        <div class="tab" @click="changeTab('isAnchor')" :class="{ active: isAnchor }">
          <img src="./img/anchor.png" alt="" v-show="!isAnchor" />
          <img src="./img/anchor_on.png" alt="" v-show="isAnchor" />
          <div>主播相关</div>
        </div>
        <div class="tab"  @click="changeTab('isUsers')" :class="{ active: isUsers }">
          <img src="./img/users.png" alt="" v-show="!isUsers" />
          <img src="./img/users_on.png" alt="" v-show="isUsers" />
          <div>用户相关</div>
        </div>
      </div>
      <div class="right" v-if="isAnchor">
        <span class="right-title" v-for="(item,index) in anchorList" :key="item.id" :class="{ actives: activeTitle == index }" @click="getHelpById(item.id,index)" >{{item.title}}</span>
        <h1>{{helpDetails.title}}</h1>
        <div class="right-content" ref="content">
        <div v-html="helpDetails.content"></div>
        </div>
      </div>
      <div class="right" v-if="isUsers">
        <span class="right-title" v-for="(item,index) in usersList" :key="item.id" :class="{ actives: activeTitle == index }" @click="getHelpById(item.id,index)" >{{item.title}}</span>
        <h1>{{helpDetails.title}}</h1>
        <div class="right-content" ref="content">
        <div v-html="helpDetails.content"></div>
        </div>
      </div>
    </div>
    <Footer />
</div>
</template>

<script>
import { post } from "@/util/http";
import Footer from "@/components/footer/footer";
export default {
name: "help",
components: { Footer },
data() {
//这里存放数据
return {
      title: "主播相关",
      activeTitle: 1,
      isUsers:false,
      isAnchor:true,
      anchorList:[],
      usersList:[],
      helpDetails:{}
};
},
created() {
this.getHelpList();
this.getHelpById(1)
},
mounted() {

},
//监听属性 类似于data概念
computed: {
},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
      toHomePage() {
        this.$router.push("/");
      },
      changeTab(text) {
        if(text == 'isAnchor') {
          this.isAnchor = true
          this.isUsers = false
          this.getHelpById(this.anchorList[0].id)
        }else if (text == 'isUsers') {
          this.isAnchor = false
          this.isUsers = true
          this.getHelpById(this.usersList[0].id)
        }
      },
async getHelpList() {
      const {
        data: { data },
      } = await post({ url: "/api/help/getHelpList" });
      this.anchorList=data.filter( item=>  {return item.id<=4})
      this.usersList=data.filter( item=>  {return item.id>4})
    },
async getHelpById(id,index) {
      this.activeTitle = index;
      const {
        data: { data },
      } = await post({ url: "/api/help/getHelpById",data: {id: parseInt(id),}});
      this.$refs.content.scrollTop = 0
      this.helpDetails = data
      }
},
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.help {
  padding-top: .56rem;
}
.title {
  width: 10.8rem;
  margin: 0 auto;
  font-size: .14rem;
  color: #666;
  padding: .3rem 0 .15rem 0;
  span {
    color: #02a8a2;
  }
  .home-page {
    color: #333;
    cursor: pointer;
  }
}
.content {
  margin: 0 auto;
  background-color: #fff;
  width: 10.8rem;
  height: 5.6rem;
  border-radius: .1rem;
  margin-bottom: .24rem;
  display: flex;
}
.left {
  padding-top: .24rem;
  width: 1.26rem;
  height: 100%;
  border-right: .01rem solid #f0f0f0;
  display: flex;
  flex-direction: column;
  .tab {
    height: .42rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    font-size: .14rem;
    border-right: .01rem solid transparent;
    cursor: pointer;
    img {
      width: .2rem;
      height: .2rem;
      margin-right: .05rem;
    }
  }
  .active {
    color: #02a8a2;
    background: rgba(2, 168, 162, 0.1);
    border-right: .01rem solid #02a8a2;
  }
}
.right {
  flex: 1;
  padding: .24rem .35rem;
.right-title{
  box-sizing: content-box;
  padding: 0 .16rem;
  border-left: .01rem solid #eee;
  font-size: .14rem;
  cursor: pointer;
    &.select,
    &:hover {
      color: #02a8a2;
    }

  &:first-child{
    border-left:none
  }
}
  .actives {
    color: #02a8a2;
  }
h1{
  text-align: center;
  margin-top: .4rem;
  margin-bottom: .2rem;
  font-weight: 600;
  font-size: .2rem;
  line-height: .28rem;
}
.right-content {
  overflow: auto;
  height: 80%;
  font-size: .14rem;
  line-height: .24rem;
}
}
</style>